import { FC } from "react";
import { AuthenticatedLayout } from "../../../layouts";
import { RQReport } from "../../../components/Reports/RQReport";

export interface IRQReportSetupPage {}

export const RQReportSetupPage: FC<IRQReportSetupPage> = () => {
	return (
		<AuthenticatedLayout
			pageTitle="RQ Report"
			breadcrumbCurrentPageName=""
			breadcrumbLinks={[]}
			mainContents={<RQReport />}
		/>
	);
};
